import { array, number, object, string } from 'yup'

const jpgMediaSizesSchema = object({
  lg: object({
    jpg: string(),
    avif: string(),
    webp: string(),
  }),
  sm: object({
    jpg: string(),
    avif: string(),
    webp: string(),
  }),
})
const pngMediaSizesSchema = object({
  lg: object({
    png: string(),
    avif: string(),
    webp: string(),
  }),
  sm: object({
    png: string(),
    avif: string(),
    webp: string(),
  }),
})

export const mediaSchema = object({
  bgLandscape: jpgMediaSizesSchema,
  bgPortrait: jpgMediaSizesSchema,
  picture: pngMediaSizesSchema,
})

const slideUrlsSchema = object({
  page: string().nullable(),
  game: string().nullable(),
  category: string().nullable(),
  url: string().nullable(),
})

export const slideSchema = object({
  description: string().nullable(),
  id: number(),
  media: mediaSchema,
  title: string().nullable(),
  urls: slideUrlsSchema,
})

export const slidesSchema = array().of(slideSchema)
